import type { VariantProps } from 'class-variance-authority'

import { Button as ButtonPrimitive } from '@base-ui/react/button'
import { cva } from 'class-variance-authority'
import { cn } from '@/lib/utils'

const buttonVariants = cva(
    'group/button inline-flex shrink-0 items-center justify-center rounded-full border border-transparent bg-clip-padding font-medium whitespace-nowrap transition-all duration-200 outline-none select-none focus-visible:ring-3 focus-visible:ring-ring/50 focus-visible:ring-offset-2 focus-visible:ring-offset-background active:not-aria-[haspopup]:translate-y-px disabled:pointer-events-none disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*="size-"])]:size-4',
    {
        variants: {
            variant: {
                default: 'bg-primary text-primary-foreground shadow-sm hover:bg-primary/90',
                timber: 'bg-timber text-timber-foreground shadow-sm hover:bg-timber/90',
                outline: 'border-border bg-transparent text-foreground hover:bg-secondary',
                secondary: 'bg-secondary text-secondary-foreground hover:bg-secondary/70',
                ghost: 'text-foreground hover:bg-secondary',
                light: 'bg-background text-foreground shadow-sm hover:bg-background/90',
                'outline-light': 'border-white/35 bg-transparent text-white hover:bg-white/10',
                link: 'h-auto rounded-none px-0 text-primary underline-offset-4 hover:underline'
            },
            size: {
                default: 'h-10 gap-2 px-5 text-sm',
                sm: 'h-8 gap-1.5 px-3.5 text-[0.8rem]',
                lg: 'h-12 gap-2 px-6 text-[15px]',
                icon: 'size-10',
                'icon-sm': 'size-8'
            }
        },
        defaultVariants: {
            variant: 'default',
            size: 'default'
        }
    }
)

type ButtonProps = ButtonPrimitive.Props & VariantProps<typeof buttonVariants>

function Button({
    className,
    variant = 'default',
    size = 'default',
    ...props
}: ButtonProps) {
    return (
        <ButtonPrimitive
            data-slot='button'
            className={cn(buttonVariants({ variant, size, className }))}
            {...props}
        />
    )
}

export { Button, buttonVariants }
